import { useMutation, gql } from '@apollo/client';
import {
  CadastrarTurmaMutation,
  CadastrarTurmaMutationVariables,
} from './__generated__/CadastrarTurmaMutation';

const CADASTRAR_TURMA_MUTATION = gql`
  mutation CadastrarTurmaMutation(
    $id_oferta: Int!
    $id_horario: Int!
    $num_turma: Int!
    $dias_semana: Int!
    $ativa: Boolean
  ) {
    cadastrarTurma(
      input: {
        id_oferta: $id_oferta
        id_horario: $id_horario
        num_turma: $num_turma
        dias_semana: $dias_semana
        ativa: $ativa
      }
    ) {
      id_turma
      id_horario
      num_turma
      dias_semana
      ativa
    }
  }
`;

const useCadastrarTurmaMutation = () => {
  return useMutation<CadastrarTurmaMutation, CadastrarTurmaMutationVariables>(
    CADASTRAR_TURMA_MUTATION
  );
};

export { useCadastrarTurmaMutation };
